/* eslint-disable sort-keys */
const locales = [
    {
        name: 'locale.country.Afghanistan',
        iso_code: '004',
        code: 'AF',
        languages: [
            {
                name: 'Persian',
                code: 'fa'
            }
        ]
    },
    {
        name: 'locale.country.Albania',
        iso_code: '008',
        code: 'AL',
        languages: [
            {
                name: 'Albanian',
                code: 'sq'
            }
        ]
    },
    {
        name: 'locale.country.Algeria',
        iso_code: '012',
        code: 'DZ',
        languages: [
            {
                name: 'Arabic',
                code: 'ar'
            }
        ]
    },
    {
        name: 'locale.country.Angola',
        iso_code: '024',
        code: 'AO',
        languages: [
            {
                name: 'Portugese',
                code: 'pt'
            }
        ]
    },
    {
        name: 'locale.country.Andorra',
        iso_code: '020',
        code: 'AD',
        languages: [
            {
                name: 'Catalan',
                code: 'ca'
            }
        ]
    },
    {
        name: 'locale.country.Anguilla',
        iso_code: '660',
        code: 'AI',
        languages: [
            {
                name: 'English',
                code: 'en'
            }
        ]
    },
    {
        name: 'locale.country.AntiguaAndBarbuda',
        iso_code: '028',
        code: 'AG',
        languages: [
            {
                name: 'English',
                code: 'en'
            }
        ]
    },
    {
        name: 'locale.country.Argentina',
        iso_code: '032',
        code: 'AR',
        languages: [
            {
                name: 'Español',
                code: 'es'
            }
        ]
    },
    {
        name: 'locale.country.Armenia',
        iso_code: '051',
        code: 'AM',
        languages: [
            {
                name: 'Armenian',
                code: 'hy'
            }
        ]
    },
    {
        name: 'locale.country.Aruba',
        iso_code: '533',
        code: 'AW',
        languages: [
            {
                name: 'Dutch',
                code: 'nl'
            }
        ]
    },
    {
        name: 'locale.country.Australia',
        iso_code: '036',
        code: 'AU',
        languages: [
            {
                name: 'English',
                code: 'en'
            }
        ]
    },
    {
        name: 'locale.country.Austria',
        iso_code: '040',
        code: 'AT',
        languages: [
            {
                name: 'German',
                code: 'de'
            }
        ]
    },
    {
        name: 'locale.country.Azerbaijan',
        iso_code: '031',
        code: 'AZ',
        languages: [
            {
                name: 'Azerbaijani',
                code: 'az'
            }
        ]
    },
    {
        name: 'locale.country.Bahamas',
        iso_code: '044',
        code: 'BS',
        languages: [
            {
                name: 'English',
                code: 'en'
            }
        ]
    },
    {
        name: 'locale.country.Bahrain',
        iso_code: '048',
        code: 'BH',
        languages: [
            {
                name: 'English',
                code: 'en'
            }
        ]
    },
    {
        name: 'locale.country.Barbados',
        iso_code: '052',
        code: 'BB',
        languages: [
            {
                name: 'English',
                code: 'en'
            }
        ]
    },
    {
        name: 'locale.country.Belarus',
        iso_code: '112',
        code: 'BY',
        languages: [
            {
                name: 'Belarusian',
                code: 'be'
            }
        ]
    },
    {
        name: 'locale.country.Belgium',
        iso_code: '056',
        code: 'BE',
        languages: [
            {
                name: 'Dutch',
                code: 'nl'
            },
            {
                name: 'French',
                code: 'fr'
            }
        ]
    },
    {
        name: 'locale.country.Belize',
        iso_code: '084',
        code: 'BZ',
        languages: [
            {
                name: 'English',
                code: 'en'
            }
        ]
    },
    {
        name: 'locale.country.Benin',
        iso_code: '204',
        code: 'BJ',
        languages: [
            {
                name: 'French',
                code: 'fr'
            }
        ]
    },
    {
        name: 'locale.country.Bermuda',
        iso_code: '060',
        code: 'BM',
        languages: [
            {
                name: 'English',
                code: 'en'
            }
        ]
    },
    {
        name: 'locale.country.Bolivia',
        iso_code: '068',
        code: 'BO',
        languages: [
            {
                name: 'Spanish',
                code: 'es'
            }
        ]
    },
    {
        name: 'locale.country.BonaireSintEustatiusAndSaba',
        iso_code: '535',
        code: 'BQ',
        languages: [
            {
                name: 'Dutch',
                code: 'nl'
            }
        ]
    },
    {
        name: 'locale.country.BosniaAndHerzegovina',
        iso_code: '070',
        code: 'BA',
        languages: [
            {
                name: 'Serbian',
                code: 'sr'
            }
        ]
    },
    {
        name: 'locale.country.Botswana',
        iso_code: '072',
        code: 'BW',
        languages: [
            {
                name: 'English',
                code: 'en'
            }
        ]
    },
    {
        name: 'locale.country.BouvetIsland',
        iso_code: '074',
        code: 'BV',
        languages: [
            {
                name: 'Norwegian',
                code: 'no'
            }
        ]
    },
    {
        name: 'locale.country.Brazil',
        iso_code: '076',
        code: 'BR',
        languages: [
            {
                name: 'Português',
                code: 'pt'
            }
        ]
    },
    {
        name: 'locale.country.BritishVirginIslands',
        iso_code: '092',
        code: 'VG',
        languages: [
            {
                name: 'English',
                code: 'en'
            }
        ]
    },
    {
        name: 'locale.country.Bulgaria',
        iso_code: '100',
        code: 'BG',
        languages: [
            {
                name: 'Bulgarian',
                code: 'bg'
            }
        ]
    },
    {
        name: 'locale.country.BurkinaFaso',
        iso_code: '854',
        code: 'BF',
        languages: [
            {
                name: 'French',
                code: 'fr'
            }
        ]
    },
    {
        name: 'locale.country.Burundi',
        iso_code: '108',
        code: 'BI',
        languages: [
            {
                name: 'Rundi',
                code: 'rn'
            }
        ]
    },
    {
        name: 'locale.country.Cambodia',
        iso_code: '116',
        code: 'KH',
        languages: [
            {
                name: 'Central Khmer',
                code: 'km'
            }
        ]
    },
    {
        name: 'locale.country.Cameroon',
        iso_code: '120',
        code: 'CM',
        languages: [
            {
                name: 'French',
                code: 'fr'
            }
        ]
    },
    {
        name: 'locale.country.Canada',
        iso_code: '124',
        code: 'CA',
        languages: [
            {
                name: 'English',
                code: 'en'
            },
            {
                name: 'Français',
                code: 'fr'
            }
        ]
    },
    {
        name: 'locale.country.CapeVerde',
        iso_code: '132',
        code: 'CV',
        languages: [
            {
                name: 'Portugese',
                code: 'pt'
            }
        ]
    },
    {
        name: 'locale.country.CaymanIslands',
        iso_code: '136',
        code: 'KY',
        languages: [
            {
                name: 'English',
                code: 'en'
            }
        ]
    },
    {
        name: 'locale.country.CentralAfricanRepublic',
        iso_code: '140',
        code: 'CF',
        languages: [
            {
                name: 'Sango',
                code: 'sg'
            }
        ]
    },
    {
        name: 'locale.country.Chad',
        iso_code: '148',
        code: 'TD',
        languages: [
            {
                name: 'Arabic',
                code: 'ar'
            }
        ]
    },
    {
        name: 'locale.country.Chile',
        iso_code: '152',
        code: 'CL',
        languages: [
            {
                name: 'Español',
                code: 'es'
            }
        ]
    },
    {
        name: 'locale.country.China',
        iso_code: '156',
        code: 'CN',
        languages: [
            {
                name: '\u4E2D\u6587',
                code: 'zh'
            },
            {
                name: 'English',
                code: 'en'
            }
        ]
    },
    {
        name: 'locale.country.Colombia',
        iso_code: '170',
        code: 'CO',
        languages: [
            {
                name: 'Español',
                code: 'es'
            }
        ]
    },
    {
        name: 'locale.country.Comoros',
        iso_code: '174',
        code: 'KM',
        languages: [
            {
                name: 'French',
                code: 'fr'
            }
        ]
    },
    {
        name: 'locale.country.CongoBrazzaville',
        iso_code: '178',
        code: 'CG',
        languages: [
            {
                name: 'Lingala',
                code: 'ln'
            }
        ]
    },
    {
        name: 'locale.country.CongoKinshasa',
        iso_code: '180',
        code: 'CD',
        languages: [
            {
                name: 'French',
                code: 'fr'
            }
        ]
    },
    {
        name: 'locale.country.CookIslands',
        iso_code: '184',
        code: 'CK',
        languages: [
            {
                name: 'Maori',
                code: 'mi'
            }
        ]
    },
    {
        name: 'locale.country.CostaRica',
        iso_code: '188',
        code: 'CR',
        languages: [
            {
                name: 'Spanish',
                code: 'es'
            }
        ]
    },
    {
        name: 'locale.country.IvoryCoast',
        iso_code: '384',
        code: 'CI',
        languages: [
            {
                name: 'French',
                code: 'fr'
            }
        ]
    },
    {
        name: 'locale.country.Croatia',
        iso_code: '191',
        code: 'HR',
        languages: [
            {
                name: 'Croatian',
                code: 'hr'
            }
        ]
    },
    {
        name: 'locale.country.Curacao',
        iso_code: '531',
        code: 'CW',
        languages: [
            {
                name: 'Dutch',
                code: 'nl'
            }
        ]
    },
    {
        name: 'locale.country.Cyprus',
        iso_code: '196',
        code: 'CY',
        languages: [
            {
                name: 'Greek',
                code: 'el'
            }
        ]
    },
    {
        name: 'locale.country.CzechRepublic',
        iso_code: '203',
        code: 'CZ',
        languages: [
            {
                name: 'Czech',
                code: 'cs'
            }
        ]
    },
    {
        name: 'locale.country.Denmark',
        iso_code: '208',
        code: 'DK',
        languages: [
            {
                name: 'Danish',
                code: 'da'
            }
        ]
    },
    {
        name: 'locale.country.Djibouti',
        iso_code: '262',
        code: 'DJ',
        languages: [
            {
                name: 'French',
                code: 'fr'
            }
        ]
    },
    {
        name: 'locale.country.Dominica',
        iso_code: '212',
        code: 'DM',
        languages: [
            {
                name: 'English',
                code: 'en'
            }
        ]
    },
    {
        name: 'locale.country.DominicanRepublic',
        iso_code: '214',
        code: 'DO',
        global_en: true,
        languages: [
            {
                name: 'Español',
                code: 'es'
            }
        ]
    },
    {
        name: 'locale.country.Ecuador',
        iso_code: '218',
        code: 'EC',
        languages: [
            {
                name: 'Spanish',
                code: 'es'
            }
        ]
    },
    {
        name: 'locale.country.Egypt',
        iso_code: '818',
        code: 'EG',
        languages: [
            {
                name: 'English',
                code: 'en'
            }
        ]
    },
    {
        name: 'locale.country.ElSalvador',
        iso_code: '222',
        code: 'SV',
        languages: [
            {
                name: 'Spanish',
                code: 'es'
            }
        ]
    },
    {
        name: 'locale.country.EquatorialGuinea',
        iso_code: '226',
        code: 'GQ',
        languages: [
            {
                name: 'Spanish',
                code: 'es'
            }
        ]
    },
    {
        name: 'locale.country.Eritrea',
        iso_code: '232',
        code: 'ER',
        languages: [
            {
                name: 'Tigrinya',
                code: 'ti'
            }
        ]
    },
    {
        name: 'locale.country.Estonia',
        iso_code: '233',
        code: 'EE',
        languages: [
            {
                name: 'Estonian',
                code: 'et'
            }
        ]
    },
    {
        name: 'locale.country.Ethiopia',
        iso_code: '231',
        code: 'ET',
        languages: [
            {
                name: 'Amharic',
                code: 'am'
            }
        ]
    },
    {
        name: 'locale.country.Fiji',
        iso_code: '242',
        code: 'FJ',
        languages: [
            {
                name: 'English',
                code: 'en'
            }
        ]
    },
    {
        name: 'locale.country.Finland',
        iso_code: '246',
        code: 'FI',
        languages: [
            {
                name: 'Finnish',
                code: 'fi'
            },
            {
                name: 'Swedish',
                code: 'sv'
            }
        ]
    },
    {
        name: 'locale.country.France',
        iso_code: '250',
        code: 'FR',
        global_en: true,
        languages: [
            {
                name: 'Français',
                code: 'fr'
            }
        ]
    },
    {
        name: 'locale.country.Gabon',
        iso_code: '266',
        code: 'GA',
        languages: [
            {
                name: 'French',
                code: 'fr'
            }
        ]
    },
    {
        name: 'locale.country.Gambia',
        iso_code: '270',
        code: 'GM',
        languages: [
            {
                name: 'English',
                code: 'en'
            }
        ]
    },
    {
        name: 'locale.country.Georgia',
        iso_code: '268',
        code: 'GE',
        languages: [
            {
                name: 'Georgian',
                code: 'ka'
            }
        ]
    },
    {
        name: 'locale.country.Germany',
        iso_code: '276',
        code: 'DE',
        languages: [
            {
                name: 'German',
                code: 'de'
            }
        ]
    },
    {
        name: 'locale.country.Ghana',
        iso_code: '288',
        code: 'GH',
        languages: [
            {
                name: 'English',
                code: 'en'
            }
        ]
    },
    {
        name: 'locale.country.Gibraltar',
        iso_code: '292',
        code: 'GI',
        global_en: true,
        languages: [
            {
                name: 'English',
                code: 'en'
            }
        ]
    },
    {
        name: 'locale.country.Greece',
        iso_code: '300',
        code: 'GR',
        languages: [
            {
                name: 'Greek',
                code: 'el'
            }
        ]
    },
    {
        name: 'locale.country.Grenada',
        iso_code: '308',
        code: 'GD',
        languages: [
            {
                name: 'English',
                code: 'en'
            }
        ]
    },
    {
        name: 'locale.country.Guadeloupe',
        iso_code: '312',
        code: 'GP',
        languages: [
            {
                name: 'French',
                code: 'fr'
            }
        ]
    },
    {
        name: 'locale.country.Guatemala',
        iso_code: '320',
        code: 'GT',
        global_en: true,
        languages: [
            {
                name: 'Español',
                code: 'es'
            }
        ]
    },
    {
        name: 'locale.country.Guinea',
        iso_code: '324',
        code: 'GN',
        languages: [
            {
                name: 'French',
                code: 'fr'
            }
        ]
    },
    {
        name: 'locale.country.GuineaBissau',
        iso_code: '624',
        code: 'GW',
        languages: [
            {
                name: 'Portugese',
                code: 'pt'
            }
        ]
    },
    {
        name: 'locale.country.Guyana',
        iso_code: '328',
        code: 'GY',
        languages: [
            {
                name: 'English',
                code: 'en'
            }
        ]
    },
    {
        name: 'locale.country.Haiti',
        iso_code: '332',
        code: 'HT',
        languages: [
            {
                name: 'French',
                code: 'fr'
            }
        ]
    },
    {
        name: 'locale.country.Honduras',
        iso_code: '340',
        code: 'HN',
        languages: [
            {
                name: 'Spanish',
                code: 'es'
            }
        ]
    },
    {
        name: 'locale.country.HongKong',
        iso_code: '344',
        code: 'HK',
        languages: [
            {
                name: 'English',
                code: 'en'
            },
            {
                name: '\u4E2D\u6587',
                code: 'zh'
            }
        ]
    },
    {
        name: 'locale.country.Hungary',
        iso_code: '348',
        code: 'HU',
        languages: [
            {
                name: 'Hungarian',
                code: 'hu'
            }
        ]
    },
    {
        name: 'locale.country.Iceland',
        iso_code: '352',
        code: 'IS',
        languages: [
            {
                name: 'Icelandic',
                code: 'is'
            }
        ]
    },
    {
        name: 'locale.country.India',
        iso_code: '356',
        code: 'IN',
        global_en: true,
        languages: [
            {
                name: 'English',
                code: 'en'
            }
        ]
    },
    {
        name: 'locale.country.Indonesia',
        iso_code: '360',
        code: 'ID',
        languages: [
            {
                name: 'Indonesian',
                code: 'in'
            }
        ]
    },
    {
        name: 'locale.country.Iraq',
        iso_code: '368',
        code: 'IQ',
        languages: [
            {
                name: 'English',
                code: 'en'
            }
        ]
    },
    {
        name: 'locale.country.Ireland',
        iso_code: '372',
        code: 'IE',
        global_en: true,
        languages: [
            {
                name: 'English',
                code: 'en'
            }
        ]
    },
    {
        name: 'locale.country.Italy',
        iso_code: '380',
        code: 'IT',
        languages: [
            {
                name: 'Italian',
                code: 'it'
            }
        ]
    },
    {
        name: 'locale.country.Jamaica',
        iso_code: '388',
        code: 'JM',
        languages: [
            {
                name: 'English',
                code: 'en'
            }
        ]
    },
    {
        name: 'locale.country.Japan',
        iso_code: '392',
        code: 'JP',
        global_en: true,
        languages: [
            {
                name: 'Japanese',
                code: 'ja'
            }
        ]
    },
    {
        name: 'locale.country.Jordan',
        iso_code: '400',
        code: 'JO',
        languages: [
            {
                name: 'Arabic',
                code: 'en'
            }
        ]
    },
    {
        name: 'locale.country.Kazakhstan',
        iso_code: '398',
        code: 'KZ',
        languages: [
            {
                name: 'Russian',
                code: 'ru'
            }
        ]
    },
    {
        name: 'locale.country.Kenya',
        iso_code: '404',
        code: 'KE',
        languages: [
            {
                name: 'English',
                code: 'en'
            }
        ]
    },
    {
        name: 'locale.country.Kiribati',
        iso_code: '296',
        code: 'KI',
        languages: [
            {
                name: 'English',
                code: 'en'
            }
        ]
    },
    {
        name: 'locale.country.Kuwait',
        iso_code: '414',
        code: 'KW',
        global_en: true,
        languages: [
            {
                name: 'English',
                code: 'en'
            }
        ]
    },
    {
        name: 'locale.country.Kyrgyzstan',
        iso_code: '417',
        code: 'KG',
        languages: [
            {
                name: 'Russian',
                code: 'ru'
            }
        ]
    },
    {
        name: 'locale.country.Latvia',
        iso_code: '428',
        code: 'LV',
        languages: [
            {
                name: 'Latvian',
                code: 'lv'
            }
        ]
    },
    {
        name: 'locale.country.Lebanon',
        iso_code: '422',
        code: 'LB',
        languages: [
            {
                name: 'English',
                code: 'en'
            }
        ]
    },
    {
        name: 'locale.country.Lesotho',
        iso_code: '426',
        code: 'LS',
        languages: [
            {
                name: 'English',
                code: 'en'
            }
        ]
    },
    {
        name: 'locale.country.Liberia',
        iso_code: '430',
        code: 'LR',
        languages: [
            {
                name: 'English',
                code: 'en'
            }
        ]
    },
    {
        name: 'locale.country.Libya',
        iso_code: '434',
        code: 'LY',
        languages: [
            {
                name: 'Arabic',
                code: 'ar'
            }
        ]
    },
    {
        name: 'locale.country.Liechtenstein',
        iso_code: '438',
        code: 'LI',
        languages: [
            {
                name: 'German',
                code: 'de'
            }
        ]
    },
    {
        name: 'locale.country.Lithuania',
        iso_code: '440',
        code: 'LT',
        languages: [
            {
                name: 'Lithuanian',
                code: 'lt'
            }
        ]
    },
    {
        name: 'locale.country.Luxembourg',
        iso_code: '442',
        code: 'LU',
        languages: [
            {
                name: 'English',
                code: 'en'
            },
            {
                name: 'German',
                code: 'de'
            },
            {
                name: 'French',
                code: 'fr'
            }
        ]
    },
    {
        name: 'locale.country.Macedonia',
        iso_code: '807',
        code: 'MK',
        languages: [
            {
                name: 'Macedonian',
                code: 'mk'
            }
        ]
    },
    {
        name: 'locale.country.Madagascar',
        iso_code: '450',
        code: 'MG',
        languages: [
            {
                name: 'French',
                code: 'fr'
            }
        ]
    },
    {
        name: 'locale.country.Malawi',
        iso_code: '454',
        code: 'MW',
        languages: [
            {
                name: 'English',
                code: 'en'
            }
        ]
    },
    {
        name: 'locale.country.Malaysia',
        iso_code: '458',
        code: 'MY',
        global_en: true,
        languages: [
            {
                name: 'English',
                code: 'en'
            }
        ]
    },
    {
        name: 'locale.country.Mali',
        iso_code: '466',
        code: 'ML',
        languages: [
            {
                name: 'French',
                code: 'fr'
            }
        ]
    },
    {
        name: 'locale.country.Malta',
        iso_code: '470',
        code: 'MT',
        languages: [
            {
                name: 'English',
                code: 'en'
            }
        ]
    },
    {
        name: 'locale.country.Martinique',
        iso_code: '474',
        code: 'MQ',
        languages: [
            {
                name: 'French',
                code: 'fr'
            }
        ]
    },
    {
        name: 'locale.country.Mauritania',
        iso_code: '478',
        code: 'MR',
        languages: [
            {
                name: 'Arabic',
                code: 'ar'
            }
        ]
    },
    {
        name: 'locale.country.Mauritius',
        iso_code: '480',
        code: 'MU',
        languages: [
            {
                name: 'English',
                code: 'en'
            }
        ]
    },
    {
        name: 'locale.country.Mexico',
        iso_code: '484',
        code: 'MX',
        languages: [
            {
                name: 'Español',
                code: 'es'
            }
        ]
    },
    {
        name: 'locale.country.Micronesia',
        iso_code: '583',
        code: 'FM',
        languages: [
            {
                name: 'English',
                code: 'en'
            }
        ]
    },
    {
        name: 'locale.country.Moldova',
        iso_code: '498',
        code: 'MD',
        languages: [
            {
                name: 'Romanian',
                code: 'ro'
            }
        ]
    },
    {
        name: 'locale.country.Monaco',
        iso_code: '492',
        code: 'MC',
        languages: [
            {
                name: 'French',
                code: 'fr'
            }
        ]
    },
    {
        name: 'locale.country.Montenegro',
        iso_code: '499',
        code: 'ME',
        languages: [
            {
                name: 'Montenegrin',
                code: 'me'
            }
        ]
    },
    {
        name: 'locale.country.Montserrat',
        iso_code: '500',
        code: 'MS',
        languages: [
            {
                name: 'English',
                code: 'en'
            }
        ]
    },
    {
        name: 'locale.country.Morocco',
        iso_code: '504',
        code: 'MA',
        languages: [
            {
                name: 'Arabic',
                code: 'ar'
            }
        ]
    },
    {
        name: 'locale.country.Mozambique',
        iso_code: '508',
        code: 'MZ',
        languages: [
            {
                name: 'Portugese',
                code: 'pt'
            }
        ]
    },
    {
        name: 'locale.country.Myanmar',
        iso_code: '104',
        code: 'MM',
        languages: [
            {
                name: 'English',
                code: 'en'
            }
        ]
    },
    {
        name: 'locale.country.Namibia',
        iso_code: '516',
        code: 'NA',
        languages: [
            {
                name: 'English',
                code: 'en'
            }
        ]
    },
    {
        name: 'locale.country.Netherlands',
        iso_code: '528',
        code: 'NL',
        languages: [
            {
                name: 'Dutch',
                code: 'nl'
            }
        ]
    },
    {
        name: 'locale.country.NewZealand',
        iso_code: '554',
        code: 'NZ',
        global_en: true,
        languages: [
            {
                name: 'English',
                code: 'en'
            }
        ]
    },
    {
        name: 'locale.country.Nicaragua',
        iso_code: '558',
        code: 'NI',
        languages: [
            {
                name: 'Spanish',
                code: 'es'
            }
        ]
    },
    {
        name: 'locale.country.Niger',
        iso_code: '562',
        code: 'NE',
        languages: [
            {
                name: 'French',
                code: 'fr'
            }
        ]
    },
    {
        name: 'locale.country.Nigeria',
        iso_code: '566',
        code: 'NG',
        languages: [
            {
                name: 'English'
            }
        ]
    },
    {
        name: 'locale.country.Norway',
        iso_code: '578',
        code: 'NO',
        languages: [
            {
                name: 'Norwegian (Bokmal)',
                code: 'nb'
            }
        ]
    },
    {
        name: 'locale.country.Oman',
        iso_code: '512',
        code: 'OM',
        languages: [
            {
                name: 'English',
                code: 'en'
            }
        ]
    },
    {
        name: 'locale.country.Pakistan',
        iso_code: '586',
        code: 'PK',
        languages: [
            {
                name: 'English',
                code: 'en'
            }
        ]
    },
    {
        name: 'locale.country.PalestinianTerritory',
        iso_code: '275',
        code: 'PS',
        languages: [
            {
                name: 'Arabic',
                code: 'ar'
            }
        ]
    },
    {
        name: 'locale.country.Panama',
        iso_code: '591',
        code: 'PA',
        languages: [
            {
                name: 'Spanish',
                code: 'es'
            }
        ]
    },
    {
        name: 'locale.country.PapuaNewGuinea',
        iso_code: '598',
        code: 'PG',
        languages: [
            {
                name: 'English',
                code: 'en'
            }
        ]
    },
    {
        name: 'locale.country.Paraguay',
        iso_code: '600',
        code: 'PY',
        languages: [
            {
                name: 'Spanish',
                code: 'es'
            }
        ]
    },
    {
        name: 'locale.country.Peru',
        iso_code: '604',
        code: 'PE',
        languages: [
            {
                name: 'Español',
                code: 'es'
            }
        ]
    },
    {
        name: 'locale.country.Philippines',
        iso_code: '608',
        code: 'PH',
        languages: [
            {
                name: 'English',
                code: 'en'
            }
        ]
    },
    {
        name: 'locale.country.Poland',
        iso_code: '616',
        code: 'PL',
        global_en: true,
        languages: [
            {
                name: 'Polski',
                code: 'pl'
            }
        ]
    },
    {
        name: 'locale.country.Portugal',
        iso_code: '620',
        code: 'PT',
        languages: [
            {
                name: 'Portugese',
                code: 'pt'
            }
        ]
    },
    {
        name: 'locale.country.PuertoRico',
        iso_code: '630',
        code: 'PR',
        languages: [
            {
                name: 'Spanish',
                code: 'es'
            }
        ]
    },
    {
        name: 'locale.country.Qatar',
        iso_code: '634',
        code: 'QA',
        global_en: true,
        languages: [
            {
                name: 'English',
                code: 'en'
            }
        ]
    },
    {
        name: 'locale.country.Reunion',
        iso_code: '638',
        code: 'RE',
        languages: [
            {
                name: 'French',
                code: 'fr'
            }
        ]
    },
    {
        name: 'locale.country.Romania',
        iso_code: '642',
        code: 'RO',
        languages: [
            {
                name: 'Romanian',
                code: 'ro'
            }
        ]
    },
    {
        name: 'locale.country.Russia',
        iso_code: '643',
        code: 'RU',
        languages: [
            {
                name: 'Russian',
                code: 'ru'
            }
        ]
    },
    {
        name: 'locale.country.Rwanda',
        iso_code: '646',
        code: 'RW',
        languages: [
            {
                name: 'French',
                code: 'fr'
            }
        ]
    },
    {
        name: 'locale.country.SaintHelena',
        iso_code: '654',
        code: 'SH',
        languages: [
            {
                name: 'English',
                code: 'en'
            }
        ]
    },
    {
        name: 'locale.country.SaintKittsAndNevis',
        iso_code: '659',
        code: 'KN',
        languages: [
            {
                name: 'English',
                code: 'en'
            }
        ]
    },
    {
        name: 'locale.country.SaintLucia',
        iso_code: '662',
        code: 'LC',
        languages: [
            {
                name: 'English',
                code: 'en'
            }
        ]
    },
    {
        name: 'locale.country.SaintVincentAndGrenadines',
        iso_code: '670',
        code: 'VC',
        languages: [
            {
                name: 'English',
                code: 'en'
            }
        ]
    },
    {
        name: 'locale.country.Samoa',
        iso_code: '882',
        code: 'WS',
        languages: [
            {
                name: 'English',
                code: 'en'
            }
        ]
    },
    {
        name: 'locale.country.SaoTomeAndPrincipe',
        iso_code: '678',
        code: 'ST',
        languages: [
            {
                name: 'Portugese',
                code: 'pt'
            }
        ]
    },
    {
        name: 'locale.country.SaudiArabia',
        iso_code: '682',
        code: 'SA',
        global_en: true,
        languages: [
            {
                name: 'English',
                code: 'en'
            }
        ]
    },
    {
        name: 'locale.country.Senegal',
        iso_code: '686',
        code: 'SN',
        languages: [
            {
                name: 'French',
                code: 'fr'
            }
        ]
    },
    {
        name: 'locale.country.Serbia',
        iso_code: '688',
        code: 'RS',
        languages: [
            {
                name: 'Serbian',
                code: 'sr'
            }
        ]
    },
    {
        name: 'locale.country.Seychelles',
        iso_code: '690',
        code: 'SC',
        languages: [
            {
                name: 'French',
                code: 'fr'
            }
        ]
    },
    {
        name: 'locale.country.SierraLeone',
        iso_code: '694',
        code: 'SL',
        languages: [
            {
                name: 'English',
                code: 'en'
            }
        ]
    },
    {
        name: 'locale.country.Singapore',
        iso_code: '702',
        code: 'SG',
        global_en: true,
        languages: [
            {
                name: 'English',
                code: 'en'
            }
        ]
    },
    {
        name: 'locale.country.SintMaarten',
        iso_code: '534',
        code: 'SX',
        languages: [
            {
                name: 'Dutch',
                code: 'nl'
            }
        ]
    },
    {
        name: 'locale.country.Slovakia',
        iso_code: '703',
        code: 'SK',
        languages: [
            {
                name: 'Slovak',
                code: 'sk'
            }
        ]
    },
    {
        name: 'locale.country.Slovenia',
        iso_code: '705',
        code: 'SI',
        languages: [
            {
                name: 'Italian',
                code: 'it'
            },
            {
                name: 'Hungarian',
                code: 'hu'
            },
            {
                name: 'Slovenian',
                code: 'sl'
            }
        ]
    },
    {
        name: 'locale.country.SolomonIslands',
        iso_code: '090',
        code: 'SB',
        languages: [
            {
                name: 'English',
                code: 'en'
            }
        ]
    },
    {
        name: 'locale.country.Somalia',
        iso_code: '706',
        code: 'SO',
        languages: [
            {
                name: 'Somali',
                code: 'so'
            }
        ]
    },
    {
        name: 'locale.country.SouthAfrica',
        iso_code: '710',
        global_en: true,
        code: 'ZA',
        languages: [
            {
                name: 'English',
                code: 'en'
            }
        ]
    },
    {
        name: 'locale.country.SouthSudan',
        iso_code: '728',
        code: 'SS',
        languages: [
            {
                name: 'English',
                code: 'en'
            }
        ]
    },
    {
        name: 'locale.country.SouthKorea',
        iso_code: '410',
        code: 'KR',
        global_en: true,
        languages: [
            {
                name: 'Korean',
                code: 'ko'
            }
        ]
    },
    {
        name: 'locale.country.Spain',
        iso_code: '724',
        code: 'ES',
        global_en: true,
        languages: [
            {
                name: 'Español',
                code: 'es'
            }
        ]
    },
    {
        name: 'locale.country.Sudan',
        iso_code: '736',
        code: 'SD',
        languages: [
            {
                name: 'English',
                code: 'en'
            }
        ]
    },
    {
        name: 'locale.country.Suriname',
        iso_code: '740',
        code: 'SR',
        languages: [
            {
                name: 'Dutch',
                code: 'nl'
            }
        ]
    },
    {
        name: 'locale.country.Swaziland',
        iso_code: '748',
        code: 'SZ',
        languages: [
            {
                name: 'English',
                code: 'en'
            }
        ]
    },
    {
        name: 'locale.country.Sweden',
        iso_code: '752',
        code: 'SE',
        languages: [
            {
                name: 'Swedish',
                code: 'sv'
            }
        ]
    },
    {
        name: 'locale.country.Switzerland',
        iso_code: '756',
        code: 'CH',
        languages: [
            {
                name: 'French',
                code: 'fr'
            },
            {
                name: 'German',
                code: 'de'
            },
            {
                name: 'Italian',
                code: 'it'
            }
        ]
    },
    {
        name: 'locale.country.Taiwan',
        iso_code: '158',
        code: 'TW',
        global_en: true,
        languages: [
            {
                name: 'Chinese',
                code: 'zh'
            }
        ]
    },
    {
        name: 'locale.country.Tajikistan',
        iso_code: '762',
        code: 'TJ',
        languages: [
            {
                name: 'Tajik',
                code: 'tg'
            }
        ]
    },
    {
        name: 'locale.country.Tanzania',
        iso_code: '834',
        code: 'TZ',
        languages: [
            {
                name: 'English',
                code: 'en'
            }
        ]
    },
    {
        name: 'locale.country.Thailand',
        iso_code: '764',
        code: 'TH',
        global_en: true,
        languages: [
            {
                name: 'English',
                code: 'th'
            }
        ]
    },
    {
        name: 'locale.country.TimorLeste',
        iso_code: '626',
        code: 'TL',
        languages: [
            {
                name: 'Portugese',
                code: 'pt'
            }
        ]
    },
    {
        name: 'locale.country.Togo',
        iso_code: '768',
        code: 'TG',
        languages: [
            {
                name: 'French',
                code: 'fr'
            }
        ]
    },
    {
        name: 'locale.country.Tonga',
        iso_code: '776',
        code: 'TO',
        languages: [
            {
                name: 'English',
                code: 'en'
            }
        ]
    },
    {
        name: 'locale.country.TrinidadAndTobago',
        iso_code: '780',
        code: 'TT',
        languages: [
            {
                name: 'English',
                code: 'en'
            }
        ]
    },
    {
        name: 'locale.country.Tunisia',
        iso_code: '788',
        code: 'TN',
        languages: [
            {
                name: 'Arabic',
                code: 'ar'
            }
        ]
    },
    {
        name: 'locale.country.Turkmenistan',
        iso_code: '795',
        code: 'TM',
        languages: [
            {
                name: 'Russian',
                code: 'ru'
            }
        ]
    },
    {
        name: 'locale.country.TurksAndCaicosIslands',
        iso_code: '796',
        code: 'TC',
        languages: [
            {
                name: 'English',
                code: 'en'
            }
        ]
    },
    {
        name: 'locale.country.Uganda',
        iso_code: '800',
        code: 'UG',
        languages: [
            {
                name: 'English',
                code: 'en'
            }
        ]
    },
    {
        name: 'locale.country.Ukraine',
        iso_code: '804',
        code: 'UA',
        global_en: true,
        languages: [
            {
                name: 'Y\u043A\u0440\u0430\u0457\u043D\u0441\u044C\u043A\u0438\u0439',
                code: 'uk'
            },
            {
                name: 'English',
                code: 'en'
            }
        ]
    },
    {
        name: 'locale.country.UAE',
        iso_code: '784',
        global_en: true,
        code: 'AE',
        languages: [
            {
                name: 'English',
                code: 'en'
            }
        ]
    },
    {
        name: 'locale.country.UnitedKingdom',
        iso_code: '826',
        code: 'GB',
        global_en: true,
        languages: [
            {
                name: 'English',
                code: 'en'
            }
        ]
    },
    {
        name: 'locale.country.Uruguay',
        iso_code: '858',
        code: 'UY',
        languages: [
            {
                name: 'Spanish',
                code: 'es'
            }
        ]
    },
    {
        name: 'locale.country.USA',
        iso_code: '840',
        code: 'US',
        languages: [
            {
                name: 'English',
                code: 'en'
            }
        ]
    },
    {
        name: 'locale.country.Uzbekistan',
        iso_code: '860',
        code: 'UZ',
        languages: [
            {
                name: 'Uzbek',
                code: 'uz'
            }
        ]
    },
    {
        name: 'locale.country.Vanuatu',
        iso_code: '548',
        code: 'VU',
        languages: [
            {
                name: 'English',
                code: 'en'
            }
        ]
    },
    {
        name: 'locale.country.Vietnam',
        iso_code: '704',
        code: 'VN',
        languages: [
            {
                name: 'Vietnamese',
                code: 'vi'
            }
        ]
    },
    {
        name: 'locale.country.VirginIslands',
        iso_code: '850',
        code: 'VI',
        languages: [
            {
                name: 'English',
                code: 'en'
            }
        ]
    },
    {
        name: 'locale.country.WesternSahara',
        iso_code: '732',
        code: 'EH',
        languages: [
            {
                name: 'Arabic',
                code: 'ar'
            }
        ]
    },
    {
        name: 'locale.country.Yemen',
        iso_code: '887',
        code: 'YE',
        languages: [
            {
                name: 'Arabic',
                code: 'ar'
            }
        ]
    },
    {
        name: 'locale.country.Zambia',
        iso_code: '894',
        code: 'ZM',
        languages: [
            {
                name: 'English',
                code: 'en'
            }
        ]
    },
    {
        name: 'locale.country.Zimbabwe',
        iso_code: '716',
        code: 'ZW',
        languages: [
            {
                name: 'English',
                code: 'en'
            }
        ]
    }
];
export default {
    currentCountry: 'US',
    currentLanguage: 'en',
    locales
};
//# sourceMappingURL=state.js.map